import type { FunctionComponent, HTMLProps, ReactNode } from 'react'
import React from 'react'

import classnames from 'classnames'

import { BaseLink } from '../Links/BaseLink'
import styles from './SquareButtonLink.module.scss'

export const SquareButtonLink: FunctionComponent<Props> = ({
  isSelected = false,
  hasBorder = false,
  className,
  children,
  testID = '',
  href = '#top',
  ...rest
}) => (
  <BaseLink
    href={href}
    includeAnimation={!isSelected}
    className={classnames(
      styles.base,
      'sb-text-small-print',
      {
        [styles.isActive]: isSelected,
        [styles.hasBorder]: hasBorder,
      },
      className
    )}
    data-testid={testID}
    {...rest}
  >
    {children}
  </BaseLink>
)

///////// IMPLEMENTATION /////////

type Props = {
  /**
   * Href attribute
   */
  href?: string | null
  /**
   * Optional classname
   */
  className?: string
  /**
   * Optional boolean to outline if button is selected
   */
  isSelected?: boolean
  /**
   * Optional boolean to control if button has a border
   */
  hasBorder?: boolean

  /**
   * Optional string for test id
   */
  testID?: string
  children: ReactNode
} & HTMLProps<HTMLAnchorElement>
